// eslint-disable-next-line import/prefer-default-export
export const entrypoint = process.env.REACT_APP_API_ENTRYPOINT;
export const defaultLocale = 'fr';
